"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SupportForce = void 0;
const force_1 = require("@/simulator/force");
const ground_1 = require("@/simulator/objects/ground");
const ball_1 = require("@/simulator/objects/ball");
const block_1 = require("@/simulator/objects/block");
const frictionForce_1 = require("./frictionForce");
class SupportForce extends force_1.Force {
    constructor(x, y, origin, _friction = 0) {
        super(x, y);
        this.origin = origin;
        this._friction = _friction;
        this.frictionForce = frictionForce_1.FrictionForce.create(this, this._friction);
    }
    update(self) {
        super.update(self);
        if (self instanceof ball_1.Ball) {
            if (this.origin instanceof ground_1.Ground && self.obj.y < self.render.canvas.height - ground_1.Ground.GROUND_HEIGHT - self.radius) {
                self.forces.removeForce(this);
                // self.forces.removeForce(this.frictionForce);
            }
        }
        else if (self instanceof block_1.Block) {
            if (this.origin instanceof ground_1.Ground && self.obj.y < self.render.canvas.height - ground_1.Ground.GROUND_HEIGHT - self.size) {
                self.forces.removeForce(this);
                // self.forces.removeForce(this.frictionForce);
            }
        }
    }
    static from(vector, origin, friction) {
        if (!origin)
            throw new Error("Cannot create a support force without providing the origin object.");
        return new SupportForce(vector.x, vector.y, origin, friction);
    }
}
exports.SupportForce = SupportForce;
